export default {
  toasts: {
    load_error: 'No se pudieron cargar las tasas',
    failed_to_save_changes: 'No se pudieron guardar los cambios',
    changes_got_saved: 'Cambios guardados',
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  rates: {
    title: 'Margen de procesamiento',
    description:
      'Porcentaje en %, más un importe fijo y un mínimo opcionales por cobro. «Cualquier método de pago» se aplica cuando no existe una tarifa específica para el método.',
    default: {
      inherits:
        'No se ha definido ninguna tarifa de Adyen, por lo que los restaurantes de este partner en el Adyen de FoodAmigos pagan la tarifa predeterminada de FoodAmigos que aparece abajo. Una tarifa definida aquí la sustituye; una tarifa definida en un restaurante concreto sigue teniendo prioridad.',
      overridden:
        'La tarifa de Adyen propia de este partner sustituye la tarifa predeterminada de FoodAmigos que aparece abajo para sus restaurantes en el Adyen de FoodAmigos. Elimínala para volver a la tarifa predeterminada.',
      own_adyen:
        'Este partner procesa los pagos en su propia cuenta de Adyen. Sus restaurantes no pagan comisión de procesamiento salvo que se establezca una tarifa aquí o en un restaurante concreto.',
      master:
        'Estas son las tarifas predeterminadas de FoodAmigos. Todos los partners en el Adyen de FoodAmigos que no tengan una tarifa de Adyen propia las utilizan.',
      rows_title: 'Tarifas predeterminadas de FoodAmigos',
    },
  },
};
